const base_url = {
  // api1: "https://apilinsoatours.odisoft.in",
  api1: "https://api.linsoatours.com",
};
export default base_url;
